// Platform-wide number formatting. Use these everywhere numbers are displayed so
// the format is consistent:
//   - money / fiat / quote sums  → 2 decimals      (100.00)
//   - percentages                → 1 decimal       (12.3%)
//   - crypto pair prices / qty   → up to 8 decimals, trailing zeros trimmed
// All return a dash for non-finite input.

export function fmtMoney(v) {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n.toFixed(2) : '—';
}

// Percent value WITHOUT the % sign (caller adds it), 1 decimal.
export function fmtPct(v) {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n.toFixed(1) : '—';
}

// Percent WITH a sign and % suffix, e.g. "+12.3%" / "-1.4%".
export function fmtPctSigned(v) {
    const n = parseFloat(v);
    if (!Number.isFinite(n)) return '—';
    return `${n >= 0 ? '+' : ''}${n.toFixed(1)}%`;
}

// Crypto price / quantity: cap at 8 decimals, strip trailing zeros, never
// scientific notation (toFixed keeps it plain).
export function fmtPrice(v) {
    const n = parseFloat(v);
    if (!Number.isFinite(n)) return '—';
    let s = n.toFixed(8);
    if (s.indexOf('.') >= 0) s = s.replace(/0+$/, '').replace(/\.$/, '');
    return s;
}

// Alias — base-asset quantities use the same rule as prices (≤8 decimals trimmed).
export const fmtQty = fmtPrice;
